import styled from 'styled-components';
import React, { useEffect, useMemo } from 'react';
// import { Row as AntdRow } from 'antd';
import { Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import './ContactUsstyle.less';
import { List } from 'antd';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import { isLocaleEnglish } from 'utils';
// import wing from '../../../assets/images/wing.svg';
import { useContactGenerali } from 'all-in-one-shared-api';
import Call from 'assets/images/support/phone.svg';
import IconEnvelope from 'assets/images/support/email.svg';
import globe from 'assets/images/support/erth.svg';
import GreetingSection from 'components/navbar/GreetingSection';
// import GreetingSection from '../../../components/navbar/GreetingSection';

// const data = ['support.contactUs', 'support.enquiry', 'support.guide', 'support.frequently'];
const ContactUsPageContainer = styled.div`
  margin: 0;
`;

function ContactUsPage() {
  const { t, i18n } = useTranslation();
  const { token, ready } = useKeycloakReady();

  const { shouldFetch, data } = useContactGenerali('useContactGenerali', token || '');
  const [isLoading, setLoading] = React.useState(false);
  // const [formData, setFormData] = useState<ContactGeneraliResponse>();

  useEffect(() => {
    shouldFetch(ready);
  }, [ready, shouldFetch]);
  // useEffect(() => {
  //   shouldFetch(ready);
  // }, [token, ready]);
  const formData = useMemo(() => {
    setLoading(true);
    if (!data) return;
    if (data) {
      setLoading(false);
      return { ...data };
    }
  }, [data]);

  const callurl = isLocaleEnglish(i18n.language) ? formData?.companyHotlineEn : formData?.companyHotlineTc;
  const openCall = () => {
    console.log('callurl888888888888', callurl);
    window.open(`tel:+${callurl?.replace(/[\s()+-]/g, '')}`, '_blank'); // 替换为你的目标链接
  };
  const emailurl = isLocaleEnglish(i18n.language) ? formData?.companyEmailEn : formData?.companyEmailTc;
  const openEmail = async () => {
    console.log('emailurl---------------------------', emailurl);
    // let url = `mailto:${emailurl}`;
    // const screenUrl = RootStackScreens.find((screenUrl) => screenUrl === url);

    // if (screenUrl) {
    //   navigation.navigate(screenUrl);
    //   return false;
    // }

    // return true;
    // try {
    //   await Linking.openURL(url);
    // } catch (error) {
    //   console.warn('无法打开邮件客户端，尝试使用网页邮箱');
    //   // 这里可以提供一个备用的邮箱链接，例如打开 Gmail 网页版
    //   let webEmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${emailurl}`;
    //   await Linking.openURL(webEmailUrl);
    // }
    const hasEmailClient = await window.open(`mailto:${emailurl}`, '_blank');
    console.log('hasEmailClient----------------', hasEmailClient);
    if (hasEmailClient) {
      await window.open(`mailto:${emailurl}`, '_blank');
    } else {
      // Alert.alert('Alert', 'Email client not found');
      console.error('Email client not found');
      // 提供用户友好的反馈，例如显示一个提醒或提示用户安装邮件应用程序
    }
  };
  const weburl = isLocaleEnglish(i18n.language) ? formData?.companyWebsiteEn : formData?.companyWebsiteTc;
  const openWeb = () => {
    window.open(weburl, '_blank'); // 替换为你的目标链接
  };
  return (
    <ContactUsPageContainer className="ContactUS">
      <GreetingSection pageName={t('life.support.contactUs')} showicon={true} />
      <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]}>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 20 }}
          lg={{ span: 24 }}
          style={{
            background: '#fff',
            maxWidth: '1384px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          className="centerlist"
        >
          <List style={{ background: '#fff', width: '672px' }} className="liststyle" loading={isLoading}>
            <div className="listcontent">
              <div className="listitem">
                <div className="tittle">
                  {t('life.contact.address')}
                  {/* <img src={wing} style={{ margin: '0  10px 0 0', width: '20px', height: '20px' }} /> */}
                </div>
                <div className="text1">
                  {isLocaleEnglish(i18n.language) ? formData?.companyAddressEn : formData?.companyAddressTc}
                </div>
              </div>
              <div className="listitem">
                <div className="tittle">
                  {t('life.contact.phone')}
                  <img
                    src={Call}
                    style={{ margin: '0  10px 0 0', width: '24px', height: '24px', cursor: 'pointer' }}
                    onClick={() => {
                      openCall();
                    }}
                  />
                </div>
                <div className="text">{`${callurl}`}</div>
              </div>
              <div className="listitem">
                <div className="tittle">
                  {t('life.contact.email')}
                  <img
                    src={IconEnvelope}
                    style={{ margin: '0  10px 0 0', width: '24px', height: '24px', cursor: 'pointer' }}
                    onClick={() => {
                      openEmail();
                    }}
                  />
                </div>
                <div className="text">{`${emailurl}`}</div>
              </div>
              <div className="listitem">
                <div className="tittle">
                  {t('life.contact.website')}
                  <img
                    src={globe}
                    style={{ margin: '0  10px 0 0', width: '24px', height: '24px', cursor: 'pointer' }}
                    onClick={() => {
                      openWeb();
                    }}
                  />
                </div>
                <div className="text">{`${weburl}`}</div>
              </div>
            </div>
          </List>
        </Col>
      </Row>
    </ContactUsPageContainer>
  );
}

export default ContactUsPage;
